import { render, staticRenderFns } from "./ConfettiRamen.vue?vue&type=template&id=ab015aee&lang=pug&"
import script from "./ConfettiRamen.vue?vue&type=script&lang=js&"
export * from "./ConfettiRamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports